const COOKIE_NAME = 'devconnect_cookie_consent';
const EVENT_NAME = 'devconnect:cookie-consent-changed';
export default class CookieConsentService {
  constructor(documentRoot, version) {
    this.document = documentRoot;
    this.version = version;
  }
  preference() {
    const prefix = `${COOKIE_NAME}=`;
    const encoded = this.document.cookie.split(';').map(part => part.trim()).find(part => part.startsWith(prefix));
    if (!encoded) return null;
    const [version, preference] = decodeURIComponent(encoded.slice(prefix.length)).split(':', 2);

    // Изменение версии политики намеренно делает прежний выбор недействительным и снова показывает понятный запрос.
    return version === this.version && ['necessary', 'analytics'].includes(preference) ? preference : null;
  }
  save(preference) {
    if (!['necessary', 'analytics'].includes(preference)) return;
    const previous = this.preference();
    const value = encodeURIComponent(`${this.version}:${preference}`);
    const secure = window.location.protocol === 'https:' ? '; Secure' : '';

    // Эта cookie хранит только выбор приватности, не содержит идентификатор пользователя и доступна 180 дней.
    this.document.cookie = `${COOKIE_NAME}=${value}; Max-Age=15552000; Path=/; SameSite=Lax${secure}`;
    window.dispatchEvent(new CustomEvent(EVENT_NAME, {
      detail: {
        preference
      }
    }));

    // Уже загруженный внешний скрипт нельзя надёжно «выгрузить», поэтому отзыв аналитики применяется чистой перезагрузкой.
    if (previous === 'analytics' && preference === 'necessary') {
      window.location.reload();
    }
  }
  reopen() {
    window.dispatchEvent(new CustomEvent('devconnect:cookie-consent-open'));
  }
}
export { EVENT_NAME };
flarum.reg.add('devconnect-legal', 'forum/service/cookieConsent', CookieConsentService);